<template>
  <div>
    <v-dialog v-model="showFormDialog">
      <report-viewer
        :reportName="Report_Name"
        :dataUrl="Report_URL"
        ref="reportViewer"
      />
    </v-dialog>
      <v-row>
        <v-col>
          <v-card>
          <v-card-title class="blue-grey--text text--darken-1 mb-4">
            Puppies: 
            <v-spacer />           
            <v-btn color="primary" v-on:click="(item) => { selectedPuppyId=null;showLitterRegistrationFormDialog(); }">
              Print registration forms
            </v-btn>
          </v-card-title>
          <v-card-text>
            <span v-if="!!litterInfo"><b>Male count: </b>{{litterInfo.malePuppiesCount}} • 
            <b>Female count: </b>{{litterInfo.femalePuppiesCount}}</span>
          <v-data-table
            :headers="headers"
            :items="litterInfo.puppies"
            class="elevation-1 full-width"
            hide-default-footer    
            :items-per-page="litterInfo.puppies.length"
            item-key="id"
          >
            <template v-slot:header.actions="{ header }">     
              <v-btn color="primary" @click="reloadData" class="mr-2">Cancel</v-btn>  
              <v-btn color="primary" @click="savePuppiesList">Save</v-btn>
            </template>
            <template v-slot:item.dogId="{ item }">
              <a :href="`/admin/dogs/${encodeURIComponent(item.dogId)}`" target="_blank" v-if="item.dogId">{{ item.dogId}}</a>
            </template>
            <template v-slot:item.released="{ item }">
              {{ item.released ? "Yes" : "" }}
            </template>
            <template v-slot:item.gender="{ item }">              
              <v-autocomplete
                v-model="item.gender"
                item-text="description"
                item-value="abbreviation"
                :items="genders"
                :rules="[(v) => !!v || 'Required']"
              />
            </template>
            <template v-slot:item.mainColor="{ item }">              
              <v-autocomplete
                v-model="item.mainColor"
                item-text="description"
                item-value="abbreviation"
                :items="mainColors"
                :rules="[(v) => !!v || 'Required']"
              />
            </template>
            <template v-slot:item.isDead="{ item }">              
              <v-checkbox
                v-model="item.isDead"
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            
                <span  v-if="!!item && !item.isNewRow">
                <v-btn class="mr-2" color="primary" :disabled="!!item.dogId" tabindex="-1" v-on:click="deletePuppy(item)">
                  <v-icon small> mdi-delete </v-icon>
                </v-btn>
                <!--
                  <router-link
                  class="no-text-decoration"
                  :to="`/admin/registerpuppy/${item.id}`"
                  v-if="item.canBeRegistered"
                >
                  <v-btn class="mr-4"> Register </v-btn>
                </router-link>
                <v-btn v-else disabled class="mr-4"> Register </v-btn>

                <router-link
                  class="no-text-decoration"
                  :to="`/admin/releasepuppy/${item.id}`"
                  v-if="item.canBeReleased"
                >
                  <v-btn class="mr-4">
                    Release
                  </v-btn>
                </router-link>
                <v-btn v-else disabled class="mr-4"> Release </v-btn>
                -->
                <v-btn color="primary" :disabled="!!item.dogId || !item.id || item.isDead" v-on:click="() => { selectedPuppyId=item.id;showPuppyRegistrationFormDialog(); }">
                  Print registration form
                </v-btn>
              </span>
            </template>
          </v-data-table>
          </v-card-text>
          </v-card>
        </v-col>
      </v-row> 
      <v-snackbar v-model="showInfoMessage" title color="green">
        {{ infoMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="showInfoMessage = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar v-model="showErrorMessage" title color="red">
        {{ errorMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>   
  </div>
</template>


<script lang="ts">
import Vue from "vue";
import ReportViewer from '../../../Admin/Reports/ReportViewer.vue';

import lookupsService from "@/services/lookupsService";
import litterService from "@/services/admin/litterService";

import { UserInfo } from "@/types/User";
import { Messages } from "@/constants";

export default Vue.extend({
  name: "LitterPuppies",
  components: {
    ReportViewer,
  },
  data: function() {
    return {
      litterInfo: {
        litterId: null, 
        owners: [] as any,
        kennels: [] as any,
        puppies: [] as any,
        whelpingDate: null as Temporal.PlainDate | null,
        whelpingDateFormatted: '',
        dam: {
          id: null
        },
        sire: {
          id: null
        },
        adminNotes: '',
        notes: ''
      } as any,
      isEditMode: false,
      headers: [
        { text: "Puppy ID", value: "id" },
        { text: "Sex", value: "gender" },
        { text: "Main Color", value: "mainColor" },
        { text: "Is Dead/Culled", value: "isDead" },
        { text: "Dog ID", value: "dogId" },
        { text: "Breeder Notes", value: "notes" },
        { text: "Released", value: "released" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      selectedPuppyId: null,
      Report_Name: 'Asca.Api.Reports.rpt2710_Puppy_Registration_Form.rdlx',
      Report_URL: '`/Admin/reports/litter/registration/${this.selectedPuppyId}`',
      showFormDialog: false,
      showValidationDialog: false, 
      validationResult: {
        warnings: [],
        errors: []
      },     
      genders: [] as any[],
      mainColors: [] as any[],
      errorMessage: '',
      infoMessage: '',
      showErrorMessage: false,
      showInfoMessage: false
    };
  },
  methods: {
    showPuppyRegistrationFormDialog: function (){   
      this.Report_Name = "Asca.Api.Reports.rpt2710_Puppy_Registration_Form.rdlx";
      this.Report_URL = "/Admin/reports/litter/registration/"+this.selectedPuppyId;
      this.showFormDialog = true;
    },
    showLitterRegistrationFormDialog: function (){
      this.Report_Name = "Asca.Api.Reports.rpt2710_Puppy_Registration_Form.rdlx";
      this.Report_URL = "/Admin/reports/litter/"+this.litterInfo.litterId+"/registration";
      this.showFormDialog = true;
    },
    reloadData: function() {
      lookupsService.getPuppyAttributes().then((res: any) => {
        this.genders = res.genders;
        this.mainColors = res.mainColors;
      });
      if (this.litterId) {
        litterService
          .getLitterById(this.litterId)
          .then((res) => {
            this.litterInfo = res;
            this.litterInfo.puppies = [...res.puppies, {isNewRow: true}];
            this.errorMessage = '';
          });
      }
    }, 
    deletePuppy(item: any) {
      const index = this.litterInfo.puppies.indexOf(item);
      this.litterInfo.puppies.splice(index, 1);
    },
    savePuppiesList: function () {
      this.$store.dispatch("changeLoaderStatus",true);
      //remove empty record
      let mappedPuppies = this.litterInfo.puppies.map((p: any) => ({
        id: p.id ? p.id : null,
        mainColor: p.mainColor,
        isDead: p.isDead ? p.isDead : null,
        gender: p.gender
      }));
      mappedPuppies.splice(mappedPuppies.length - 1, 1);
      litterService
                .editLitterPuppies(this.litterInfo.litterId, mappedPuppies)
                .then((res: any) => {
                  if(res.success){                   
                    this.reloadData();
                    this.infoMessage = Messages.SaveSuccessful;
                    this.showInfoMessage = true;
                  } else {              
                    this.errorMessage =  Messages.SaveError + " " + res.messages.join(', ');
                    this.showErrorMessage = true;
                  }
                })
                .catch((e: any) => {
                    this.errorMessage =  Messages.SaveError;
                    this.showErrorMessage = true;                  
                })
                .finally(() => this.$store.dispatch("changeLoaderStatus",false));
    }
  },
  created: function() {
    this.reloadData();
  },
  watch: {
    litterId: function(newVal: String) {
      this.reloadData();
    },
    lastRow: function(newVal, oldVal){
        const isNewRowAdded = Object.keys(newVal).length > 1;
        if(isNewRowAdded){          
          this.litterInfo.puppies = [...this.litterInfo.puppies, {}];
          this.litterInfo.puppies[this.litterInfo.puppies.length - 2].isNewRow = false;
          this.litterInfo.puppies[this.litterInfo.puppies.length - 1].isNewRow = true;
        }
    },
  },
  props: {
    litterId: { type: Number },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    lastRow(): Object {
        return this.litterInfo.puppies[this.litterInfo.puppies.length - 1];
    }
  },
});
</script>
